import { ReturnParameterValue } from '../schemas/ReturnParameterValue';
import { FilterParameterAndParameterValues } from '../components/productPage/ProductHome';
import { ReturnParameterValueInFilter } from '../schemas/ReturnParameterValueInFilter';
import { ReturnParameterInFilter } from '../schemas/ReturnParameterInFilter';
import { DisplayName } from '../schemas/DisplayName';

export const replacePercent20ToSpace = (str: string): string => {
    return str
        .replace(/%20/g, ' ')
        .replace(/%2F/g, '/')
        .replace(/%26/g, '&')
        .replace(/%2C/g, ',')
        .replace(/%28/g, '(')
        .replace(/%29/g, ')');
};

export const getDisplayNameWithFallback = (
    displayNames: DisplayName[] | undefined,
    language: string,
    fallbackName: string
): string => {
    if (!displayNames || displayNames.length === 0) return fallbackName || '';

    const displayName = displayNames.find((dn) => dn.language === language);
    const fallbackDisplay = !displayName
        ? displayNames.find((dn) => dn.language === 'ENGLISH')
        : null;

    return displayName?.display || fallbackDisplay?.display || fallbackName || '';
};

export const getDisplayNameForParameter = (
    parameter: ReturnParameterValue,
    language: string
): string => {
    if (!parameter) return '';
    return getDisplayNameWithFallback(
        parameter.parameterDisplayNames,
        language,
        parameter.parameterName
    );
};

export const getDisplayNameForFilterParameter = (
    parameter: FilterParameterAndParameterValues,
    language: string
): string => {
    if (!parameter) return '';

    return getDisplayNameWithFallback(
        parameter.parameterDisplayNames,
        language,
        parameter.parameterName
    );
};

export const getDisplayNameForReturnParameterValue = (
    parameterValue: ReturnParameterValueInFilter | undefined,
    language: string
): string => {
    if (!parameterValue) {
        return '';
    }
    if (parameterValue.displayNames && parameterValue.displayNames.length > 0) {
        const found = parameterValue.displayNames.find((name) => name.language === language);
        if (found && found.display) {
            return found.display;
        }
    }
    if (parameterValue.formattedValue !== null && parameterValue.formattedValue !== undefined) {
        return String(parameterValue.formattedValue);
    }
    return String(parameterValue.value);
};

export const getDisplayNameForReturnParameterInFilter = (
    param: ReturnParameterInFilter,
    language: string
) => {
    if (!param) return '';
    return getDisplayNameWithFallback(param.parameterDisplayNames, language, param.parameterName);
};

/**
 * 100000 ➜ "100,000"
 * 1234567.89 ➜ "1,234,567.89"
 * 不是數字則原樣回傳
 */
export function addComma(value: unknown): string {
    // ① 如果本來就是 number，就直接用
    if (typeof value === 'number' && Number.isFinite(value)) {
        return formatNum(value);
    }

    // ② 如果是「只含數字的小數字串」，先轉成 number 再格式化
    if (typeof value === 'string' && /^[+-]?\d+(\.\d+)?$/.test(value.trim())) {
        return formatNum(Number(value));
    }

    // ③ 其他型別或包含單位（pcs／Ω…）就原樣回傳
    return String(value);
}

function formatNum(n: number) {
    return n
        .toString()
        .replace(
            /^(-?\d+)(\.\d+)?$/,
            (_m, intPart: string, dec = '') => intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + dec
        );
}
